export const getFileName = (folderName, file) => {
    let fileStringArr = file.split(folderName + '/')
    let fileName = decodeURIComponent(fileStringArr[1])
    return fileName
}